<template>
    <aside class="main-sidebar">
        <section class="sidebar">
            <div @click="toggleSidebar()">
                <ul class="sidebar-menu" data-widget="tree">
                    <li><router-link to="/admin"><i class="icon feather icon-layers"></i> <span>Площадки</span></router-link></li>
                    <li><router-link to="/admin/users"><i class="icon feather icon-users"></i> <span>Пользователи</span></router-link></li>
                    <li><router-link to="/admin/categories"><i class="icon feather icon-list"></i> <span>Категории</span></router-link></li>
                    <li><router-link to="/admin/requests"><i class="icon feather icon-archive"></i> <span>Публикации задач</span></router-link></li>
                    <li><router-link to="/admin/bundles"><i class="icon feather icon-percent"></i> <span>Пакетные предложения</span></router-link></li>
                    <li><router-link to="/admin/market"><i class="icon feather icon-shopping-bag"></i> <span>Биржа CPM</span></router-link></li>
                    <li><router-link to="/admin/withdrawal"><i class="icon feather icon-gift"></i> <span>Выплаты</span></router-link></li>
                    <li><router-link to="/admin/links"><i class="icon feather icon-external-link"></i> <span>Кастомные ссылки</span></router-link></li>
                    <li><router-link to="/admin/configs"><i class="icon feather icon-settings"></i> <span>Настройки</span></router-link></li>
                </ul>
            </div>
        </section>
        <!-- /.sidebar -->
    </aside>
</template>

<script>
    export default {
        name: "Sidebar",
        data: function () {
            return {
            }
        },
        methods: {
            toggleSidebar: function () {
                $('.sidebar-open .sidebar-toggle').trigger('click');
            }
        },
    }
</script>

<style scoped>
    .sidebar {
        padding-top: 7px;
    }
    button {
        font-weight: 400;
    }
    .buttons-switch {
        text-align: center;
    }
    .selected {
        background: rgba(255, 255, 255, 0.4117647058823529);
    }
    .el-button-group .el-button--primary:last-child {
        border-left-color: transparent;
    }
    .el-button-group .el-button--primary:first-child {
        border-right-color: transparent;
    }
    .el-button-group>.el-button:not(:last-child) {
        margin-right: 0px;
    }
    .sidebar-mini.sidebar-collapse .el-button-group,.sidebar-mini.sidebar-collapse .notifications-menu {
        display: none;
    }
    li {
        list-style-type: none;
    }
    .notifications-menu {
        text-align: right;
        margin-top: -51px;
        margin-bottom: 23px;
        margin-right: 10px;
        width: 39px;
        float: right;
    }
    .notifications-menu button {
        color: #409eff;
        border: 0px;
    }
    .dropdown-menu {
        min-width: 250px;
    }
    .media-heading {
        font-size: 13px;
    }
    .media-body {
        font-size: 12px;
    }
    .notifications-menu .footer {
        text-align: center;
        margin-top: -8px;
    }
</style>
